import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, ListItem, ListItemButton, ListItemText, List, ListItemIcon, IconButton } from "@mui/material";
import { DeploymentContext } from "./DeploymentPage";
import { FlexContainer } from "../../components/FlexContainer";
import { RobotRecordingStatus } from "../../api/robocore/dex_interfaces";
import { useEffect, useState } from "react";
import { RobotAgent } from "../../panels/worldpanelparts/robot/RobotAgent";
import { AgentEvents } from "../../panels/worldpanelparts/agents/BaseAgent";
import { DeleteForever, UploadFileOutlined } from "@mui/icons-material";
import { deleteBlob, saveModel } from "../../api/connection";
import { ROBOCORE_BLOB_CONTAINER } from "../../models/Robot";

export function RobotSettingsDialog({ ctx, setCtx }: { ctx: DeploymentContext, setCtx: (ctx: DeploymentContext) => void }) {
  const [recordingCount, setRecordingCount] = useState(0);
  const [recordingUrl, setRecordingUrl] = useState('');
  useEffect(() => {
    if (!ctx.agent) return;
    const agentListener = async (dgram: Partial<RobotAgent>) => {
      // Handle state changes
      if (dgram.recordingStatus) {
        if (dgram.recordingStatus.startsWith(`${RobotRecordingStatus.Uploaded}_`)) {
          const [, blobName] = dgram.recordingStatus.split('_');
          const deployment = ctx.deployment;
          deployment.recordings = deployment.recordings || [];
          if (!deployment.recordings.includes(blobName)) {
            deployment.recordings.push(blobName);
          }
          await saveModel(deployment);
          setCtx({
            ...ctx,
            settingsOpen: true,
            deployment: { ...deployment }
          });
        } else if (dgram.recordingStatus.startsWith(`${RobotRecordingStatus.Response},`)) {
          const [, count, blobUrl] = dgram.recordingStatus.split(',');
          setRecordingCount(parseInt(count));
          setRecordingUrl(blobUrl);
        }
      }
    };
    ctx.agent.on(AgentEvents.StateChange, agentListener);

    return () => {
      ctx.agent?.off(AgentEvents.StateChange, agentListener);
    }
  }, [ctx.agent]);

  useEffect(() => {
    if (ctx.settingsOpen && ctx.agent) {
      ctx.agent.requestRecording(RobotRecordingStatus.Request);
    }
  }, [ctx.settingsOpen, ctx.agent]);

  const agent = ctx.agent!;
  return (
    <Dialog open={ctx.settingsOpen || false} onClose={() => setCtx({ ...ctx, settingsOpen: false })} maxWidth="sm" fullWidth>
      <DialogTitle>Robot Settings</DialogTitle>
      <DialogContent>
        <div>
          <Typography variant="h6" gutterBottom>Recordings</Typography>
          <List>
            {(ctx.deployment.recordings || []).map(rec =>
              <ListItem key={rec} disablePadding dense>
                <ListItemButton onClick={() => {
                  const url = recordingUrl!.replace('?', `/${rec}?`);
                  window.open(url, '_blank');
                }}>
                  <ListItemText primary={rec} />
                </ListItemButton>
                <ListItemIcon>
                  <IconButton onClick={async () => {
                    const deployment = ctx.deployment;
                    deployment.recordings = deployment.recordings.filter(r => r !== rec);
                    await saveModel(deployment);
                    await deleteBlob(ROBOCORE_BLOB_CONTAINER, rec);
                    setCtx({ ...ctx, deployment });
                  }}>
                    <DeleteForever />
                  </IconButton>
                </ListItemIcon>
              </ListItem>
            )}
          </List>

          <FlexContainer>
            <div></div>
            <div>
              <Button disabled={recordingCount === 0} color="secondary" onClick={() => {
                agent.requestRecording(`${RobotRecordingStatus.Upload}_${ctx.deployment._id}`);
              }}>
                <UploadFileOutlined style={{ marginRight: 8 }} />
                Upload video and telemetry
              </Button>
            </div>
          </FlexContainer>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='secondary' onClick={() => setCtx({ ...ctx, settingsOpen: false })}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}